import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FeedbackModel } from 'src/app/shared/models/feedback.model';
import * as Config from 'src/app/config/app.constant'
import { UserModel } from 'src/app/shared/models/user.model';
import { FeedbackService } from '../service/feedback.service';
import { MenuModel } from 'src/app/shared/models/menu.model';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  user: UserModel;
  form: FormGroup;
  menu: MenuModel[];

  constructor(
    private fb: FormBuilder,
    private feedbackService: FeedbackService
  ) {
    this.user = JSON.parse(sessionStorage.getItem(Config.USER_DETAIL));
  }

  ngOnInit(): void {
    this.getMenu();
    this.buildForm();
  }

  getMenu(): void {
    this.menu = [];
    this.feedbackService.getAllMenu().subscribe(
      (res: any) => {
        this.menu = res.resultData;
      }, err => {
        console.log("error -> ", err)
      }
    );
  }

  buildForm(): void {
    this.form = this.fb.group({
      menu: ['', [Validators.required]],
      feedback: ['', [Validators.required]],
    });
  }

  save(): void {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.valid) {
      const params = new FeedbackModel();
      params.menuId = this.form.controls.menu.value;
      params.feedbackDescription = this.form.controls.feedback.value;
      params.userId = this.user.customer.userID;
      params.createBy = this.user.customer.username;
      params.hospitalCode = this.user.customer.hosCode;
      params.hospitalName = this.user.customer.hosName;
      this.feedbackService.saveFeedback(params).subscribe(
        (res: any) => {
          console.log('res: ', res);
        }, err => {
          console.log("error -> ", err)
        }
      );
    }
  }

  clear(): void {
    this.form.reset();
    this.form.updateValueAndValidity();
  }

}
